import { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { shopPath } from "../../routes";
import { useCart } from "../../context/CartContext";
import { displayPriceText, inferSubcategory, normalizedCategory, onlyOneInStock, usableChoices } from "../../data/catalog";
import ItemGallery from "./ItemGallery";
import PurchasePanel from "./PurchasePanel";
import SelectedItems from "./SelectedItems";

// Full-screen item details: photos, description and the add-to-cart controls.
export default function ItemViewer({ item, onClose, closing = false, onMouseMove, onMouseEnter }) {
  useLayoutEffect(() => {
    const header = document.querySelector("header.top");
    const place = () => {
      if (header) document.documentElement.style.setProperty("--v200-product-top", `${header.offsetTop + header.offsetHeight}px`);
    };
    place();
    window.addEventListener("resize", place);
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(place) : null;
    if (header) observer?.observe(header);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", place);
      document.documentElement.style.removeProperty("--v200-product-top");
    };
  }, []);
  const { piecesOf } = useCart();
  const hasChoices = usableChoices(item).length > 0;
  const inCart = piecesOf(item.id);
  const outOfStock = item.inStock === false;
  const department = normalizedCategory(item);
  const subcategory = inferSubcategory(item);

  return (
    <div
      className={`modalShade on${closing ? " closing" : ""}`}
      id="productShade"
      onMouseMove={onMouseMove}
      onMouseEnter={onMouseEnter}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <section className="productModal" role="dialog" aria-modal="true" aria-labelledby="productTitle">
        <button type="button" className="modalClose" id="productClose" aria-label="Done" onClick={onClose}>
          Done
        </button>
        <div className="modalGrid">
          <ItemGallery key={item.id} item={item} />
          <div className="pdetails">
            <button type="button" className="productBackShopping" onClick={onClose}>Done</button>
            <div className="tag" id="productCat">
              {normalizedCategory(item)} · {inferSubcategory(item)}
            </div>
            <h2 id="productTitle">{item.name}</h2>
            <div className="productDescription" id="productDescription">
              Description: {item.description || "Brand New"}
            </div>
            {onlyOneInStock(item) && <div className="singleStockNote">Only 1 in stock</div>}
            {item.size && <div className="productSizeLine">{item.size}</div>}
            <div className="bigprice" id="productPrice">
              <span className="productPriceLine">{displayPriceText({ ...item, deal: "" }, false)}</span>
              {item.deal && <span className="productBundleLine">{item.deal}</span>}
            </div>
        <nav className="productBreadcrumb" aria-label="Product breadcrumb">
          <Link to={shopPath({ department })}>All {department}</Link>
          {subcategory && subcategory !== "All" && (
            <>
              <span aria-hidden="true">—</span>
              <Link to={shopPath({ department, subcategory })}>{subcategory === "Kid" ? "Kids" : subcategory}</Link>
            </>
          )}
          <span className="productBreadcrumbTitleSeparator" aria-hidden="true">—</span>
          <span className="productBreadcrumbTitle" aria-current="page">{item.name}</span>
        </nav>
            {hasChoices && <SelectedItems item={item} />}
            {!hasChoices && !outOfStock && (
              <div className="productCartStatus" id="productCartStatus">
                {inCart > 0 ? `In your bag: ${inCart}` : ""}
              </div>
            )}
            <div id="productOptions">{outOfStock && <strong style={{ color: "#b42318" }}>Out of stock</strong>}</div>
            {!outOfStock && <PurchasePanel key={item.id} item={item} />}
          </div>
        </div>
      </section>
    </div>
  );
}
